module.exports = __webpack_public_path__ + "img/20190710164548700.9a7c12ab.png";